import React, { useEffect, useMemo } from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";

import ErrorMessage from "@/components/atoms/ErrorMessage";
import Footer from "@/components/molecules/Footer";
import Header from "@/components/molecules/Header";
import SucessMessage from "@/components/atoms/SucessMessage";
import i18n from "@/translate/i18n";
import { useTransactionData } from "@/context/transactionContext";
import Button from "@/components/atoms/Buttons/Button";

const TIME_TO_REDIRECT = 5000;

const isValidUrl = (urlString) => {
  if (!urlString) return false;
  try {
    return Boolean(new URL(urlString));
  } catch (e) {
    return false;
  }
};

function DepositStatus() {
  const location = useLocation();
  const history = useHistory();
  const { id, token } = useParams();

  const dataFromState = location.state?.data;
  const { transactionData: dataFromContext } = useTransactionData();

  const transactionData = dataFromState || dataFromContext;
  const validationNeeded = false;

  const hasValidRedirectUrl = useMemo(
    () => isValidUrl(transactionData?.redirect_url),
    [transactionData?.redirect_url],
  );

  useEffect(() => {
    const timer = setTimeout(() => {
      if (
        transactionData?.status === "completed" &&
        !validationNeeded &&
        hasValidRedirectUrl
      ) {
        window.location.href = transactionData.redirect_url;
      }
    }, TIME_TO_REDIRECT);
    return () => {
      clearTimeout(timer);
    };
  }, [transactionData, validationNeeded, hasValidRedirectUrl]);

  if (!transactionData?.id) {
    return (
      <div className="flex justify-center items-center bg-white sm:bg-gray-900 font-arboria-book min-h-screen" />
    );
  }

  return (
    <div className="flex justify-center items-center bg-white sm:bg-gray-900 font-arboria-book min-h-screen overflow-x-hidden">
      <div className="flex flex-col justify-between items-center w-[500px] rounded-[20px] overflow-hidden text-center">
        <Header
          transactionData={transactionData}
          title={
            transactionData?.status === "completed"
              ? i18n.t("confirmation.titleSucess")
              : i18n.t("confirmation.titleFail")
          }
        />
        {transactionData?.status === "completed" ? (
          <SucessMessage
            title={i18n.t("confirmation.congrats")}
            subtitle={i18n.t("confirmation.content")}
            handleClick={
              hasValidRedirectUrl
                ? () => window.location.replace(transactionData?.redirect_url)
                : null
            }
          />
        ) : transactionData?.status === "pending" ? (
          <SucessMessage
            title={i18n.t("confirmation.confirmedTransaction")}
            messageDescription={i18n.t("confirmation.pendingMessage")}
            handleClick={
              hasValidRedirectUrl
                ? () => window.location.replace(transactionData?.redirect_url)
                : null
            }
          />
        ) : (
          <ErrorMessage
            isExpired={transactionData?.status === "expired"}
            transactionData={transactionData}
            handleClick={() =>
              history.replace(`/${id}/${token}${history.location.search}`)
            }
          >
            {i18n.t([
              `error.transaction.${transactionData?.message}`,
              "error.transaction.unspecific",
            ])}
          </ErrorMessage>
        )}
        {validationNeeded && (
          <Button
            type="button"
            handleClick={() => {
              const externalUrl =
                "https://magic.veriff.me/v/eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpYXQiOjE3NjI5NjkwOTgsInNlc3Npb25faWQiOiI0YTZmZTczYy1kMTA2LTRmMzUtOWI4ZS1kM2ZlMGI1Mzk5MzciLCJpaWQiOiI2MDRjOGI5YS1mYzFlLTRhMmEtYjlmMy1kMmE0MzAyYzQyMjQiLCJ2aWQiOiI4ZmRiNmJkOC1kZWEyLTQ4NGQtYTk5Yi0yYzY3MjA0N2RkZDIiLCJjaWQiOiJmYWxjb24tNCIsImV4cCI6MTc2MzU3Mzg5OH0.cMKwiw04eIvTs-ut3vKQ1VqYPQ8AlZJ9io4-Q1QAEMc";
              window.open(externalUrl, "_blank", "noopener,noreferrer");
            }}
          >
            {i18n.t("confirmation.validateIdentityNow")}
          </Button>
        )}
        <Footer />
      </div>
    </div>
  );
}

export default DepositStatus;
